import React from "react";
import { motion } from "framer-motion";
import fabric from '../../img/fabric.svg';

const buttonSpan = {
  initial: { width: 40},
  hover: { backgroundColor: '#e16f32', width: 170}
}

const iconSvg = {
  initial: {width: 26, height: 26},
  hover: {width: 26, height: 26}
}

const buttonLabel = {
  initial: { display: 'hidden', width: 0, opacity: 0},
  hover: { display: 'block', width: '100%', opacity: 1, paddingLeft: 5}
}

const TableauPublicBtn = ({link, colour}) => (
    <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
        <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[6px] py-[6px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
          <motion.svg variants={iconSvg} className="fill-current text-grey-500 inline-block h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
          <g>
          <path d="M78.9,317.9H53.2v-43.2H14.6v-23.9h38.6v-43.2h25.7v43.2h38.6v23.9H78.9V317.9z M116.7,225.9v-62.5H58.7v-25.8h57.9V76
          h27.6v61.6h57.9v25.8h-57.9v62.5H116.7z M202.2,360.2v25.8h-57.9v61.6h-28.5v-61.6h-57v-25.8h57v-62.5h28.5v62.5H202.2z
          M265.6,347.3h-31.3v-69H170v-31.3h64.4v-69.9h31.3v69.9H330v31.3h-64.4V347.3z M237.1,141.3V98.1h-38.6v-23h38.6V30.9h25.8v44.1
          h38.6v23h-38.6v43.2H237.1z M262.9,385.9v43.2h38.6v23h-38.6v44.1h-25.8v-44.1h-38.6v-23h38.6v-43.2H262.9z M298.7,164.3v-26.7h57
          V76h28.5v61.6h57v26.7h-57v61.6h-28.5v-61.6H298.7z M384.3,297.6v62.5h57v25.8h-57v61.6h-28.5v-61.6h-57v-25.8h57v-62.5H384.3z
          M446.8,250.7h38.6v23.9h-38.6v43.2h-25.8v-43.2h-38.6v-23.9h38.6v-43.2h25.8V250.7z"/>
          </g>
          </motion.svg>
          <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">Tableau Public</motion.span>
        </motion.span>
      </motion.a>
)

const AlteryxCommunityBtn = ({link, colour}) => (
    <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
        <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[6px] py-[6px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
        <svg className="fill-current text-grey-500 inline-block h-6 w-6 mt-[1px] ml-[2px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
          <path d="M297.9,393.7l-1.6,1.2l-1.7,1c-29.8,20.6-74.3,34.4-110.8,34.4h0c-53.5-1.2-73-20.1-74.1-71.6
            c1.2-59.3,21-77.6,87.8-81.8l92.2-4.3l4.1-0.2l4-0.1V393.7z M465.9,422.9c-3-10-11.3-16.1-21.4-16.1c-2.7,0.1-5.2,0.3-8.4,1
            c-14.3,3.4-22.2,4.5-33.2,5.3c-20.9,1-24.6-7.1-25.9-30.6V61.4c-0.6-7.4-4.5-14.8-10.2-19.3l-2.1-1.3c-0.7-0.5-1.3-1.2-2.2-1.6
            C345,28.9,316,20.6,291.4,14.4l-1.8-0.5C260.3,6.8,228,3.1,196,3.1c-18.8,0-35.7,1.4-42.5,2.3c-14.1,1.4-52,7.7-64.7,12
            c-3.7,1.2-15.7,6.9-16.1,18.2c0.2,5.9,6.8,24.6,6.8,24.6c4.3,13.1,8.9,16.3,17.2,18c6.7,0.8,21-2.3,30.6-3.9
            c24.7-4.6,40.9-6.3,52.5-6.4c15-0.2,33.8-0.4,55.9,2.7c41.9,6.4,58.1,19.3,58.1,19.3v124.7l-3.7,0.1l-89.6,2.2
            C80.8,220.8,25.3,268.3,26.1,364c-0.2,43.5,13.4,78.3,39.4,100.9c24.1,21.2,59.5,32.3,102,32.3h0.2c48.8,0,90.9-15.1,131.8-47.5
            l3.9-3l2,4.5c9.8,21.7,26.6,35.7,49.7,41.6c10.3,2.9,22.1,4.4,37.2,4.4c3.9,0,7.8-0.2,11.2-0.6c13.7-1.9,31.9-4.3,52.1-13.9
            c11.1-5.3,19-11.8,18.4-23.5C473.6,448.9,465.9,422.9,465.9,422.9"/>
          </svg>
          <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">Alteryx</motion.span>
        </motion.span>
      </motion.a>
)

const TwitterBtn = ({link, colour}) => (
    <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
        <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[6px] py-[6px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
          <svg width="30" height="30" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-current text-grey-500 inline-block h-6 w-6 mt-[2px] ml-[2px]">
              <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
          </svg>
          <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">X.com</motion.span>
        </motion.span>
      </motion.a>
)

const LinkedInBtn = ({link, colour}) => (
    <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
        <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[6px] py-[6px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
          <svg className="fill-current text-grey-500 inline-block h-6 w-6 mt-[2px] ml-[2px]" xmlns="http://www.w3.org/2000/svg" style={{paddingTop: 1, paddingBottom: 2}} viewBox="0 0 85 85">
          <g>
          <path d="M1.7,28.4h17.5v56.2H1.7V28.4z M10.5,0.5c5.6,0,10.1,4.5,10.1,10.1s-4.5,10.1-10.1,10.1S0.3,16.2,0.3,10.6l0,0
        C0.3,5,4.9,0.5,10.5,0.5"/>
          <path d="M30.2,28.4h16.7V36h0.3c3.4-5.8,9.8-9.3,16.5-9.1c17.7,0,20.9,11.6,20.9,26.7v30.8H67.1V57.2c0-6.5-0.1-14.9-9.1-14.9
            s-10.5,7.1-10.5,14.4v27.8H30.2V28.4z"/>
          </g>
          </svg>
          <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">LinkedIn</motion.span>
        </motion.span>
      </motion.a>
)

const GithubBtn = ({link, colour}) => (
    <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
        <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[6px] py-[6px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
        <svg className="fill-current text-grey-500 inline-block h-6 w-6 ml-[2px] mt-[2px]" viewBox="0 0 98 96" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"/></svg>
          <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">Github</motion.span>
        </motion.span>
      </motion.a>
)

const FabricBtn = ({link, colour}) => (
  <motion.a href={link} whileHover="hover" initial="initial" target="_blank" rel="noopener noreferrer">
      <motion.span variants={buttonSpan} className={`h-10 align-middle inline-flex px-[8px] py-[8px] ml-1 rounded-full uppercase font-title tracking-[0.04em] text-sm bg-${colour ? colour : 'orange'}-700 text-white cursor-pointer shadow-md`}>
      <img src={fabric} className="h-6"/>
        <motion.span variants={buttonLabel} className="truncate w-full pt-[5px] align-middle text-center">Fabric</motion.span>
      </motion.span>
    </motion.a>
)

export {
    TableauPublicBtn,
    AlteryxCommunityBtn,
    TwitterBtn,
    LinkedInBtn,
    GithubBtn,
    FabricBtn
}